export default __webpack_public_path__ + "static/media/user.c47b10f3.svg";